/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class DDayGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "countUp_DDAY";
    static BITMAP_FONT_WAYS_COUNT_UP = "WaysCountUp";
    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static WIN_WAYS_COUNTER_NUMBERS: string = "waysVerticalCountup";
    public static FREESPIN_GAME_BACKGROUND: string = "freespinBackground";
    public static SUPER_FREESPIN_GAME_BACKGROUND: string = "superFreespinBackground";
    public static REEL_FRAME: string = "reelFrame";
    public static BRICK: string = "brick";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(DDayGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/countUp_DDAY.fnt"),
                    new BitmapFontAsset(DDayGameAssets.BITMAP_FONT_WAYS_COUNT_UP, "fonts/bitmapfonts/WaysCountUp.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json")
                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "freespinBackground": "freespinBackground",
                    "superFreespinBackground": "superfreespinBackground",
                }
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json")
                ],
                animations: {
                    "reelBackground": "ui/reelframe/reelBg",
                    "reelFrame": "ui/reelframe/reelframe",
                    "waysFrame": "ui/reelframe/ways",
                    "waysVerticalCountup": "ui/reelframe/waysVerticalCountup",
                    "maxCap": "BigWin/maxcap",
                    "brick": "ui/reelframe/metalcover",
                    "logo": "logo/logo_portrait",
                    "wires": "ui/reelframe/wires",
                    "knob": "ui/reelframe/knob"
                }
            },
            {
                name: "jpegHigh",
                assets: [
                    new TextureAsset("jpegHigh0", "sheets/jpegHigh/jpegHigh0.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json")
                ],
                animations: {
                    "bwArrows": "ArrowFireParticle/particleArrow_Fire_",
                    "static_charge": "static_charge/static_charge"
                }
            },
            {
                name: "mainPng",
                assets: [
                    new TextureAsset("mainPng0", "sheets/mainPng/mainPng0.json")
                ],
                animations: {
                    "xBetPopUpBg": "xBet/bubbleBox",
                    "outro_neptune": "outro/neptuneSpins_outro",
                    "outro_invasion": "outro/invasionSpins_outro",
                    "outro_overload": "outro/overlordSpins_outro",
                    "intro_neptune": "feature_name/neptuneSpins",
                    "intro_invasion": "feature_name/invasionSpins",
                    "intro_overload": "feature_name/overlordSpins",
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                    new TextureAsset("symbols2", "sheets/symbols/symbols2.json"),
                    new TextureAsset("symbols3", "sheets/symbols/symbols3.json"),
                    new TextureAsset("symbols4", "sheets/symbols/symbols4.json"),
                    new TextureAsset("symbols5", "sheets/symbols/symbols5.json"),
                    new TextureAsset("symbols6", "sheets/symbols/symbols6.json"),
                    new TextureAsset("symbols7", "sheets/symbols/symbols7.json"),
                    new TextureAsset("symbols8", "sheets/symbols/symbols8.json"),
                    new TextureAsset("symbols9", "sheets/symbols/symbols9.json"),
                    new TextureAsset("symbols10", "sheets/symbols/symbols10.json")
                ],
                animations: {}
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("Wild", "spine/Wilds.json"),
                    new SpineAsset("W2", "spine/W2.json"),
                    new SpineAsset("xBetButton", "spine/xBetButton.json"),
                    new SpineAsset("radio", "spine/radio_signal.json"),
                    new SpineAsset("radio1", "spine/radio_signal1.json"),
                    new SpineAsset("radio2", "spine/radio_signal2.json"),
                    new SpineAsset("radio3", "spine/radio_signal3.json"),
                    new SpineAsset("radio4", "spine/radio_signal4.json"),
                    new SpineAsset("fsOutro", "spine/FS_outro.json"),
                    new SpineAsset("Anticipation", "spine/Anticipation.json"),
                    new SpineAsset("bulletHole", "spine/bullethole.json"),
                    new SpineAsset("transform", "spine/transform.json"),
                    new SpineAsset("fighterPlaneBullet", "spine/stuka_bullet.json"),
                    new SpineAsset("Explosion", "spine/Explosion.json"),
                    new SpineAsset("Artillery", "spine/Artillery.json"),
                    new SpineAsset("WinEffect", "spine/Win_fx.json"),
                    new SpineAsset("bomber", "spine/bomber.json"),
                    new SpineAsset("bigWin", "spine/bigwin.json"),
                    new SpineAsset("capWin", "spine/CapWin.json"),
                    new SpineAsset("atomicWild", "spine/atomicWild_intro.json"),
                    new SpineAsset("freespinBGEffects", "spine/freespinBG_effects.json"),
                    new SpineAsset("xBetBackground", "spine/xbet_transition.json"),
                    new SpineAsset("introSpinText", "spine/spin_text.json"),
                    new SpineAsset("introLight", "spine/PnC_light.json"),
                    new SpineAsset("introSelectTitle", "spine/PnC_text.json"),
                    new SpineAsset("introFeatures", "spine/PnC_features.json"),
                    new SpineAsset("introGeneral1", "spine/airforce_general.json"),
                    new SpineAsset("introGeneral2", "spine/navy_general.json"),
                    new SpineAsset("introGeneral3", "spine/tank_general.json"),
                    new SpineAsset("introTable", "spine/PnC_table.json"),
                    new SpineAsset("introGeneral4", "spine/general1.json"),
                    new SpineAsset("introGeneral5", "spine/general2.json"),
                    new SpineAsset("introAtomicWildList", "spine/atomicWild_list.json"),
                    new SpineAsset("introPanzerList", "spine/panzer_list.json"),
                    new SpineAsset("introStukaList", "spine/stuka_list.json"),
                    new SpineAsset("introBomberList", "spine/bomber_list.json"),
                    new SpineAsset("introHowitzerList", "spine/howitzer_list.json"),
                    new SpineAsset("introFeaturesList", "spine/features_list.json"),
                    new SpineAsset("bomb", "spine/drop_bomb.json"),
                    new SpineAsset("introBG", "spine/PnC_BG.json"),
                ]
            }
        ]
    };
}
